var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9 1.9C12.9 1.40294 12.497 1 12 1C11.5029 1 11.1 1.40294 11.1 1.9V3.14492C6.90328 3.56636 3.56636 6.90328 3.14492 11.1H1.9C1.40294 11.1 1 11.5029 1 12C1 12.497 1.40294 12.9 1.9 12.9H3.14492C3.56636 17.0967 6.90328 20.4336 11.1 20.855V22.1C11.1 22.5971 11.5029 23 12 23C12.497 23 12.9 22.5971 12.9 22.1V20.855C17.0967 20.4336 20.4336 17.0967 20.855 12.9H22.1C22.5971 12.9 23 12.497 23 12C23 11.5029 22.5971 11.1 22.1 11.1H20.855C20.4336 6.90328 17.0967 3.56636 12.9 3.14492V1.9ZM6.1 12.9H4.95648C5.36147 16.1015 7.89843 18.6385 11.1 19.0435V17.9C11.1 17.4029 11.5029 17 12 17C12.497 17 12.9 17.4029 12.9 17.9V19.0435C16.1015 18.6385 18.6385 16.1015 19.0435 12.9H17.9C17.4029 12.9 17 12.497 17 12C17 11.5029 17.4029 11.1 17.9 11.1H19.0435C18.6385 7.89843 16.1015 5.36147 12.9 4.95648V6.1C12.9 6.59706 12.497 7 12 7C11.5029 7 11.1 6.59706 11.1 6.1V4.95648C7.89843 5.36147 5.36147 7.89843 4.95648 11.1H6.1C6.59706 11.1 7 11.5029 7 12C7 12.497 6.59706 12.9 6.1 12.9Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetOutline);
export default __webpack_public_path__ + "static/media/target_outline.235a0f48485d5574f58c77d4dd4d50ff.svg";
export { ForwardRef as ReactComponent };